import React from 'react';
import { medium } from '@unmind/design-system-components-web';
import { rem } from 'polished';
import { css, styled } from 'styles';
import RoutePath from 'App/RoutePath';
import PageCard from 'Shared/PageCard/PageCard';
import { Namespace } from 'i18next';
import { useTranslation } from 'react-i18next';
import { UserFeature } from '__generated__/globalTypes';
import { HomeScreenSection } from '../PersonalisedTodayScreen';
import Coaching from './assets/therapy_coaching.png';
import Tools from './assets/wellbeing_tools.png';
import Helplines from './assets/helplines.png';
import Managers from './assets/managers_training.png';

const CardsContainer = styled.div<{ cardCount?: number }>`
  display: grid;
  grid-gap: ${rem(20)};
  flex-wrap: wrap;
  justify-content: center;
  grid-template-columns: repeat(2, 1fr);

  ${({ cardCount }) =>
    css`
      ${medium(css`
        justify-content: flex-start;
        grid-template-columns: repeat(${cardCount}, 1fr);
      `)}
    `};
`;

type SupportForYouProps = {
  userFeatures: UserFeature[];
  supportFeatureCount: number;
  isManagerExperienceActive: boolean;
};

const SupportForYou = ({
  userFeatures,
  supportFeatureCount,
  isManagerExperienceActive,
}: SupportForYouProps) => {
  const { t: translate } = useTranslation<Namespace<'homepage'>>('homepage');
  const cardCount = supportFeatureCount >= 3 ? supportFeatureCount : 3;

  return (
    <HomeScreenSection>
      <CardsContainer cardCount={cardCount}>
        {userFeatures.includes(UserFeature.TALK) && (
          <PageCard
            title={translate('support_for_you_section.therapy_card_title')}
            imageSrc={Coaching}
            to={RoutePath.Talk}
          />
        )}

        <PageCard
          title={translate('support_for_you_section.wellbeing_card_title')}
          imageSrc={Tools}
          to={RoutePath.Explore}
        />

        {userFeatures.includes(UserFeature.HELP) && (
          <PageCard
            title={translate('support_for_you_section.help_card_title')}
            imageSrc={Helplines}
            to={RoutePath.Help}
          />
        )}

        {userFeatures.includes(UserFeature.LINE_MANAGER_CONTENT) &&
          isManagerExperienceActive && (
            <PageCard
              title={translate('support_for_you_section.managers_card_title')}
              imageSrc={Managers}
              to={RoutePath.Managers}
            />
          )}
      </CardsContainer>
    </HomeScreenSection>
  );
};

export default SupportForYou;
